import Logger from "../../../Overrides/Logger";
export function isCustomSuccessResponse(response) {
    return response.identity !== undefined &&
        response.reference !== undefined && response.status_code !== undefined
        && response.identified !== undefined;
}
// ... existing code ...
export function isCustomSubscriptionExistsResponse(response) {
    const candidate = response;
    Logger.info("custom subscription exists response", {
        "payload": candidate,
        "reference": candidate.reference !== undefined,
        "status_code": candidate.status_code !== undefined,
        "forbidden": candidate.forbidden !== undefined,
        "identified": candidate.identified !== undefined,
        "jwt": candidate.jwt !== undefined,
        "valid": candidate.reference !== undefined
            && candidate.status_code !== undefined
            && candidate.forbidden !== undefined
            && candidate.identified !== undefined
            && candidate.jwt !== undefined
    });
    return candidate.reference !== undefined
        && candidate.status_code !== undefined
        && candidate.forbidden !== undefined
        && candidate.identified !== undefined
        && candidate.jwt !== undefined;
}
export function isCustomFailureResponse(response) {
    return response.identity !== undefined &&
        response.reference !== undefined && response.status_code !== undefined;
}
